import { useEffect } from "react";

const APP_STORE_URL = "https://apps.apple.com/kr/app/id6760615740";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=app.case_d.tobo";

const HERO_BG = [
  "radial-gradient(ellipse 55% 50% at 80% 10%, rgba(139,92,246,0.25) 0%, transparent 60%)",
  "radial-gradient(ellipse 45% 40% at 15% 90%, rgba(99,102,241,0.15) 0%, transparent 55%)",
  "radial-gradient(ellipse 90% 70% at 50% 40%, #5a3fa8 0%, #44308a 55%, #2e1f60 100%)",
].join(", ");

const FEATURES = [
  {
    icon: "🃏",
    title: "플래시카드 학습",
    bg: "#ede9fe",
    text: (
      <>
        스와이프 한 번으로 <strong>알고 있음 / 학습 중</strong> 분류. 모르는 단어만 다시 만나는 반복 학습으로 시간 낭비
        없이 집중할 수 있어요.
      </>
    ),
    plus: false,
  },
  {
    icon: "📝",
    title: "실전 퀴즈",
    bg: "#dbeafe",
    text: (
      <>
        4지선다 퀴즈로 실력을 확인하세요. 자주 틀린 단어일수록 더 자주 출제되는 <strong>가중치 랜덤 시스템</strong>으로
        약점을 집중 공략해요.
      </>
    ),
    plus: false,
  },
  {
    icon: "🔄",
    title: "스마트 복습",
    bg: "#fde4e7",
    text: (
      <>
        에빙하우스 망각 곡선을 기반으로, 잊기 직전에 딱 맞춰 단어를 다시 보여줘요. 한 번 외운 단어는 오래오래
        기억됩니다.
      </>
    ),
    plus: true,
  },
];

const REVIEWS = [
  {
    text: "출퇴근 시간에 매일 30분씩 했더니 두 달 만에 점수가 확 올랐어요. 플래시카드가 생각보다 훨씬 효율적이에요.",
    author: "직장인 jihyeon_k · 토익 795점 달성",
  },
  {
    text: "단어 외우는 게 이렇게 재밌을 줄 몰랐어요. 스와이프 인터페이스가 중독적이라서 자꾸 하게 됩니다.",
    author: "대학생 study_minjae · 매일 학습 중",
  },
  {
    text: "퀴즈 오답 노트 기능이 너무 편해요. 틀린 단어만 모아서 다시 볼 수 있는 게 특히 좋아요.",
    author: "취준생 sooyeon_dev · 토익 830점 준비 중",
  },
  {
    text: "다른 앱들이랑 비교했을 때 UI가 압도적으로 깔끔해요. 광고 없이 집중할 수 있는 Plus 플랜 추천합니다.",
    author: "직장인 hyunwoo_toeic · Plus 구독 중",
  },
  {
    text: "망각 곡선 복습 기능 덕분에 한 번 외운 단어를 잊어버리는 일이 없어졌어요. 과학적인 학습법 최고!",
    author: "대학원생 seulki_plus · 스마트 복습 사용 중",
  },
  {
    text: "즐겨찾기 기능으로 내가 자주 틀리는 단어만 모아서 따로 플래시카드 학습할 수 있어서 너무 좋아요!",
    author: "고등학생 yuna_english · 매일 이용 중",
  },
];

const PERK_LABELS = [
  <>
    망각 곡선 기반 <strong>스마트 복습</strong> 미니 퀴즈
  </>,
  <>
    <strong>토익 800 · 900</strong> 고급 단어 세트 무제한
  </>,
  <>
    <strong>즐겨찾기 덱</strong>으로 내 취약 단어만 모아 학습
  </>,
  <>
    광고 없이 <strong>완전 집중</strong> 학습 환경
  </>,
  <>
    주간 학습 차트로 <strong>성장 데이터</strong> 확인
  </>,
];

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={22} height={22}>
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
  </svg>
);

const GooglePlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={22} height={22}>
    <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" />
  </svg>
);

function SectionTag({ children, dark = false }: { children: React.ReactNode; dark?: boolean }) {
  return (
    <div
      className={`inline-block text-[12px] font-bold tracking-[1.5px] uppercase px-3 py-[5px] rounded-full mb-4 ${
        dark ? "text-[#a5b4fc] bg-white/10" : "text-tertiary bg-violet-100"
      }`}
    >
      {children}
    </div>
  );
}

export function SupportPage() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sp-visible");
          }
        });
      },
      { threshold: 0.12 },
    );

    const els = document.querySelectorAll(".sp-reveal");

    els.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{`
        @keyframes scroll-reviews {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .sp-reviews-track {
          display: flex;
          gap: 20px;
          width: max-content;
          animation: scroll-reviews 30s linear infinite;
        }
        .sp-reviews-track:hover { animation-play-state: paused; }
        .sp-reveal {
          opacity: 0;
          transform: translateY(28px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }
        .sp-reveal.sp-visible {
          opacity: 1;
          transform: translateY(0);
        }
        .sp-delay-1 { transition-delay: 0.1s; }
        .sp-delay-2 { transition-delay: 0.2s; }
        .sp-delay-3 { transition-delay: 0.3s; }
        .sp-btn-store:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(0,0,0,0.3); }
        .sp-feature-card:hover { transform: translateY(-4px); box-shadow: 0 20px 48px rgba(49,46,129,0.12); }
        .sp-btn-dl:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(49,46,129,0.2); }
        .sp-plus-cta:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(0,0,0,0.3); }
        .sp-nav-cta:hover { background: #2e1f60; transform: translateY(-1px); }
        .sp-footer-link:hover { color: rgba(255,255,255,0.8); }
      `}</style>

      <div className="bg-white text-gray-900">
        {/* NAV */}
        <nav className="sticky top-0 z-100 bg-white/88 backdrop-blur-md border-b border-gray-200 px-[5%] h-16 flex items-center justify-between">
          <a href="#" className="flex items-center gap-[10px] no-underline">
            <img src="/logo.png" alt="TOBO 로고" className="w-9 h-9 rounded-[10px] object-cover" />
            <span className="font-extrabold text-[20px] text-indigo-900 tracking-[-0.5px]">TOBO</span>
          </a>
          <a
            href="#download"
            className="sp-nav-cta bg-indigo-900 text-white font-bold text-[14px] px-5 py-[10px] rounded-full no-underline transition-[background,transform] duration-200"
          >
            무료 다운로드
          </a>
        </nav>

        {/* HERO */}
        <section
          style={{ backgroundImage: HERO_BG }}
          className="min-h-svh flex items-center px-[5%] pt-[80px] pb-[60px] gap-12 overflow-hidden relative flex-wrap flex-col md:flex-row justify-center"
        >
          <div className="flex-1 max-w-[520px] relative z-1 min-w-[280px] flex flex-col items-center">
            <div className="inline-flex items-center gap-[6px] bg-white/10 border border-white/15 text-white/80 text-[13px] font-semibold px-[14px] py-[6px] rounded-full mb-7 backdrop-blur-md">
              <span>📖</span> 토익 700 · 800 · 900 완전정복
            </div>

            <h1 className="font-black text-[clamp(40px,5vw,68px)] leading-[1.05] text-white tracking-[-2px] mb-6 text-center">
              <span className="text-[#F5CC3C]">토익 단어</span>,
              <br />
              이번엔 진짜로.
            </h1>

            <p className="text-[clamp(15px,1.8vw,18px)] text-white/65 leading-[1.8] mb-10 text-center">
              플래시카드로 익히고, 퀴즈로 확인하고,
              <br />
              <strong className="text-white/90 font-semibold">망각 곡선 기반 스마트 복습</strong>으로 완성하는
              <br />
              가장 효율적인 토익 단어 학습법.
            </p>

            <div id="download" className="flex gap-3 flex-wrap">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
                className="sp-btn-store flex items-center gap-[10px] px-[22px] py-[14px] rounded-[14px] no-underline bg-white text-tertiary min-w-[160px] transition-[transform,box-shadow] duration-200"
              >
                <AppleIcon />
                <div className="flex flex-col">
                  <span className="text-[10px] font-medium opacity-60 tracking-[0.3px]">Download on the</span>
                  <span className="font-bold text-[15px] tracking-[-0.3px]">App Store</span>
                </div>
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noreferrer"
                className="sp-btn-store flex items-center gap-[10px] px-[22px] py-[14px] rounded-[14px] no-underline bg-white/10 border border-white/20 text-white min-w-[160px] transition-[transform,box-shadow] duration-200"
              >
                <GooglePlayIcon />
                <div className="flex flex-col">
                  <span className="text-[10px] font-medium opacity-60 tracking-[0.3px]">Get it on</span>
                  <span className="font-bold text-[15px] tracking-[-0.3px]">Google Play</span>
                </div>
              </a>
            </div>
          </div>

          <div className="flex-none flex items-end gap-5 relative z-1">
            <img src="/mock_main.png" alt="메인 대시보드 화면" className="h-130 w-auto object-contain rounded-[40px]" />
          </div>
        </section>

        {/* FEATURES */}
        <section className="bg-white px-[5%] py-24">
          <div className="text-center mb-14">
            <SectionTag>Core Features</SectionTag>
            <h2 className="font-black text-[clamp(28px,4vw,48px)] text-indigo-900 tracking-[-1.5px] leading-[1.1] mb-4">
              외우고, 확인하고,
              <br />
              절대 잊지 않게.
            </h2>
            <p className="text-[16px] text-gray-500 leading-[1.8] max-w-[500px] mx-auto">
              단순히 단어장 보는 것과는 다릅니다.
              <br />
              TOBO는 기억이 유지되는 방식으로 설계되었어요.
            </p>
          </div>

          <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5 max-w-[1100px] mx-auto">
            {FEATURES.map((card, i) => (
              <div
                key={i}
                className={`sp-reveal sp-feature-card${i > 0 ? ` sp-delay-${i}` : ""} bg-[#f4f6ff] rounded-[24px] p-9 border border-indigo-600/8 transition-[transform,box-shadow] duration-300 relative overflow-hidden`}
              >
                <div
                  style={{ background: card.bg }}
                  className="w-[52px] h-[52px] rounded-[16px] flex items-center justify-center text-[24px] mb-5"
                >
                  {card.icon}
                </div>
                <h3 className="font-extrabold text-[22px] text-indigo-900 tracking-[-0.5px] mb-[10px]">{card.title}</h3>
                <p className="text-[14px] text-gray-500 leading-[1.8]">{card.text}</p>

                {card.plus && (
                  <div className="inline-flex items-center gap-1 mt-4 bg-primary text-white text-[11px] font-bold px-[10px] py-1 rounded-md">
                    👑 Plus 전용
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* REVIEWS */}
        <section className="bg-tertiary px-[5%] py-24 overflow-hidden">
          <div className="text-center mb-14">
            <SectionTag dark>User Reviews</SectionTag>
            <h2 className="font-black text-[clamp(28px,4vw,48px)] text-white tracking-[-1.5px] leading-[1.1]">
              사용자들이 먼저
              <br />
              경험했어요
            </h2>
          </div>

          <div className="overflow-hidden w-full py-4 -my-4 mask-[linear-gradient(to_right,transparent_0%,black_6%,black_94%,transparent_100%)]">
            <div className="sp-reviews-track">
              {[...REVIEWS, ...REVIEWS].map((review, i) => (
                <div
                  key={i}
                  className="bg-white/6 border border-white/10 rounded-[20px] p-7 w-[300px] shrink-0 backdrop-blur-md"
                >
                  <div className="text-amber-400 text-[14px] mb-3 tracking-[2px]">★★★★★</div>
                  <p className="text-[14px] text-white/80 leading-[1.8] mb-4">"{review.text}"</p>
                  <div className="text-[12px] text-white/40 font-semibold">{review.author}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="bg-[#f4f6ff] px-[5%] py-24">
          <div className="max-w-[1100px] mx-auto text-center lg:text-left">
            <SectionTag>How it works</SectionTag>
            <h2 className="font-black text-[clamp(28px,4vw,48px)] text-indigo-900 tracking-[-1.5px] leading-[1.1]">
              딱 3단계,
              <br />
              바로 시작하세요.
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-[60px]">
              {[
                {
                  num: "1",
                  img: "/mock_word_set.png",
                  alt: "단어 세트 선택",
                  title: "세트 선택",
                  desc: "토익 700 · 800 · 900 중\n나의 목표 점수에 맞는 세트를 골라요.",
                },
                {
                  num: "2",
                  img: "/mock_flash_card.png",
                  alt: "플래시카드 학습",
                  title: "플래시카드 학습",
                  desc: "모르는 단어는 왼쪽, 아는 단어는 오른쪽.\n매일 조금씩, 확실하게 쌓아가요.",
                },
                {
                  num: "3",
                  img: "/mock_test.png",
                  alt: "퀴즈 화면",
                  title: "퀴즈로 실력 확인",
                  desc: "4지선다 퀴즈로 내 실력을 측정하고\n오답은 자동으로 복습 대상이 돼요.",
                },
              ].map((step, i) => (
                <div
                  key={i}
                  className={`sp-reveal${i > 0 ? ` sp-delay-${i}` : ""} flex flex-col items-center text-center`}
                >
                  <div className="w-10 h-10 bg-indigo-900 text-white rounded-full flex items-center justify-center font-extrabold text-[16px] mb-4 shrink-0">
                    {step.num}
                  </div>
                  <img src={step.img} alt={step.alt} className="w-[200px] h-auto object-contain mb-6" />
                  <h3 className="font-extrabold text-[20px] text-indigo-900 tracking-[-0.5px] mb-2">{step.title}</h3>
                  <p className="text-[14px] text-gray-500 leading-[1.7] whitespace-pre-line">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PLUS SECTION */}
        <div className="px-[5%] py-24 relative overflow-hidden bg-tertiary">
          <div className="max-w-[1100px] mx-auto flex flex-col items-center gap-10 lg:grid lg:grid-cols-2 lg:items-center lg:gap-[60px] relative z-1">
            {/* 텍스트 */}
            <div>
              <div className="inline-flex items-center gap-[6px] bg-primary text-white text-[13px] font-bold px-[14px] py-[6px] rounded-md mb-5">
                👑 TOBO Plus
              </div>
              <h2 className="font-black text-[clamp(28px,4vw,48px)] text-white tracking-[-1.5px] leading-[1.1] mb-3">
                더 스마트하게,
                <br />더 빠르게.
              </h2>
              <p className="text-[16px] text-white/60 leading-[1.8] max-w-[400px] mb-9">
                기본 기능은 무료. Plus로 업그레이드하면 토익 고득점을 위한 모든 도구를 사용할 수 있어요.
              </p>

              <ul className="list-none flex flex-col gap-[14px]">
                {PERK_LABELS.map((label, i) => (
                  <li key={i} className="flex items-center gap-3 text-[15px] text-white/85">
                    <span className="w-[22px] h-[22px] bg-white/20 rounded-full flex items-center justify-center text-[13px] shrink-0 text-white">
                      ✓
                    </span>
                    <span>{label}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#download"
                className="sp-plus-cta mt-9 inline-flex items-center gap-2 bg-white text-indigo-900 font-extrabold text-[15px] px-7 py-4 rounded-[14px] no-underline transition-[transform,box-shadow] duration-200"
              >
                지금 시작하기 →
              </a>
            </div>

            {/* 가격 카드 */}
            <div className="w-full max-w-[480px] lg:max-w-none bg-white/6 border border-white/12 rounded-[28px] px-7 pt-7 pb-6 backdrop-blur-md">
              <div className="text-[13px] text-white/50 mb-5 font-semibold">구독 플랜 선택</div>

              {[
                { name: "월간 구독", price: "4,900", per: "월 · 언제든 해지 가능", badge: null, active: false },
                { name: "3개월 구독", price: "12,900", per: "3개월 · 월 4,300원", badge: "12% 절약", active: true },
                { name: "연간 구독", price: "39,000", per: "1년 · 월 3,250원", badge: "33% 절약", active: false },
              ].map((plan, i) => (
                <div
                  key={i}
                  className={`px-[18px] py-4 rounded-[14px] ${i > 0 ? "mt-2" : ""} ${
                    plan.active
                      ? "border-[1.5px] border-white/35 bg-white/13 shadow-[0_0_0_3px_rgba(255,255,255,0.06)]"
                      : "border-[1.5px] border-transparent"
                  }`}
                >
                  <div className="flex justify-between items-center mb-1">
                    <span className="font-bold text-white text-[14px]">{plan.name}</span>
                    {plan.badge && (
                      <span
                        className={`text-[10px] font-bold px-[9px] py-[3px] rounded-full tracking-[0.2px] ${
                          plan.active ? "bg-white text-indigo-900" : "bg-primary text-white"
                        }`}
                      >
                        {plan.badge}
                      </span>
                    )}
                  </div>
                  <div className="font-black text-[26px] text-white tracking-[-1px] leading-[1.1]">
                    {plan.price}
                    <span className="text-[14px] font-semibold">원</span>
                  </div>
                  <div className="text-[12px] text-white/50 mt-[3px]">{plan.per}</div>
                </div>
              ))}

              <div className="mt-5 text-[11px] text-white/30 leading-[1.6] text-center">
                구독은 앱 내 구매로 진행됩니다.
                <br />
                구독 기간 중 언제든지 해지할 수 있어요.
              </div>
            </div>
          </div>
        </div>

        {/* FINAL CTA */}
        <section className="bg-[#f4f6ff] px-[5%] py-24 text-center">
          <SectionTag>무료 시작</SectionTag>
          <h2 className="font-black text-[clamp(28px,4vw,48px)] text-indigo-900 tracking-[-1.5px] leading-[1.1] mb-4 max-w-[600px] mx-auto">
            오늘부터 시작하면
            <br />
            내일이 달라져요.
          </h2>
          <p className="text-[16px] text-gray-500 leading-[1.8] max-w-[500px] mx-auto mb-10">
            토익 700 기본 세트와 핵심 기능은 완전 무료.
            <br />
            지금 바로 다운로드하고 첫 번째 플래시카드를 넘겨보세요.
          </p>

          <div className="flex justify-center gap-4 flex-wrap">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="sp-btn-dl inline-flex items-center gap-[10px] px-7 py-4 rounded-[16px] font-bold text-[15px] no-underline bg-indigo-900 text-white transition-[transform,box-shadow] duration-200"
            >
              <AppleIcon />
              <span>App Store 다운로드</span>
            </a>
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noreferrer"
              className="sp-btn-dl inline-flex items-center gap-[10px] px-7 py-4 rounded-[16px] font-bold text-[15px] no-underline bg-white text-indigo-900 border-2 border-gray-200 transition-[transform,box-shadow] duration-200"
            >
              <GooglePlayIcon />
              <span>Google Play 다운로드</span>
            </a>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="bg-tertiary px-[5%] py-12 flex justify-between items-center flex-wrap gap-5">
          <div>
            <div className="flex items-center gap-[10px]">
              <span className="font-extrabold text-[18px] text-white/70">TOBO</span>
            </div>
            <div className="text-[12px] text-white/30 mt-1">© 2026 TOBO. All rights reserved.</div>
          </div>

          <div className="flex gap-6 flex-wrap">
            {[
              { href: "/terms", label: "이용약관" },
              { href: "/privacy", label: "개인정보처리방침" },
              { href: "mailto:support@case-d.com", label: "문의하기" },
            ].map(link => (
              <a
                key={link.href}
                href={link.href}
                className="sp-footer-link text-[13px] text-white/40 no-underline transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </div>
        </footer>
      </div>
    </>
  );
}
